import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as appConstants from '../../../constants/appConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';

class AccordionBtn extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            parentScreen: this.props.parentScreen,
            screen: this.props.screen,
            className: "",
            locale: appHelper.getLocalData(this.props.screen),
            update: false,
            icon: {}
        };
        this.setClass = this.setClass.bind(this);
        this.onClicked = this.onClicked.bind(this);
        this.screenIsEnabled = this.screenIsEnabled.bind(this);
        this.screenIsComplete = this.screenIsComplete.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
    }

    componentDidMount() {
        this.setClass();
        if (this.state.parentScreen.include_icon) {
            this.getAssets();
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen)
            });
        }
    }

    screenIsEnabled(){
        return appHelper.getArrayObjectIndexByKey(this.props.enabledScreens, "screen_id", this.props.screen.screen_id);
    }

    screenIsComplete(){
        return appHelper.getArrayObjectIndexByKey(this.props.completeScreens, "screen_id", this.props.screen.screen_id);
    }

    setClass() {
        let className = "";

        if (this.screenIsEnabled() === -1) {
            className += "disabled ";
        }

        if (this.screenIsComplete() > -1) {
            className += "complete ";
        }else{
            className += "incomplete ";
        }

        return className;
    }

    onClicked() {
        if (this.screenIsEnabled() > -1 && !this.props.isAnimating) {
            this.props.biteCallbacks.toggleAccordion(this.props.screen);
        }
    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.onClicked();
        }
    }

    getAssets() {
        let icon = {};

        if (appHelper.isDefined(this.state.screen.assets.icon)) {
            icon = appHelper.getIconAsset(this.state.screen.assets.icon);
        }

        this.setState({
            icon: Object.assign({}, icon)
        });
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    render() {
        return (
            <div className={`accordion-btn ${this.setClass()}`} onClick={this.onClicked} onKeyDown={this.setKeyboardAccessibility} tabIndex={0} role="link" id={`accordion_btn_${this.state.screen.screen_id}`}>
                {this.state.parentScreen.include_icon && appHelper.isDefined(this.state.icon.src)
                    ?
                    <div className="accordion-icon">
                        <img src={this.getImagePath(this.state.icon.src)} alt=""/>
                    </div>
                    :
                    null
                }
                <div className="accordion-label" dangerouslySetInnerHTML={{__html: this.state.locale.title}} />
            </div>
        );

    }
}

AccordionBtn.propTypes = {
    parentScreen: PropTypes.object.isRequired,
    screen: PropTypes.object.isRequired,
    activeScreenId: PropTypes.number.isRequired,
    enabledScreens: PropTypes.array.isRequired,
    completeScreens: PropTypes.array.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    isAnimating: PropTypes.bool.isRequired,
    contentData: PropTypes.object,
    trackingData: PropTypes.object,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

AccordionBtn.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AccordionBtn);



/** WEBPACK FOOTER **
 ** ./src/components/screens/accordionScreen/AccordionBtn.js
 **/